const reduxStoreExternal = {
    sourceDataHeaders: {},
    sourceDataRows: {},
    nodesSource: {},
    initialNodesSource: {}
};
export default reduxStoreExternal;
